import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { checkStepGate, getStep, WORKFLOW_STEPS, type StepKey, type StepProgress } from '@luogen/shared';

/** 工作流状态：当前在哪一步、每一步是否已产出结果 */
export const useWorkflowStore = defineStore('workflow', () => {
  const currentStep = ref<StepKey>('topic');
  const progress = ref<StepProgress>({});
  const busy = ref(false);

  const steps = computed(() => WORKFLOW_STEPS);
  const currentMeta = computed(() => getStep(currentStep.value));
  const currentIndex = computed(() => currentMeta.value.index);

  /** 已完成到第几步（用于进度条） */
  const completedCount = computed(
    () => WORKFLOW_STEPS.filter((step) => progress.value[step.key]).length,
  );

  function markDone(key: StepKey) {
    progress.value = { ...progress.value, [key]: true };
  }

  function reset(key: StepKey) {
    const next = { ...progress.value };
    delete next[key];
    progress.value = next;
  }

  /** 切换步骤；被门槛拦下时返回提示语 */
  function goTo(key: StepKey): string | null {
    const blocked = checkStepGate(key, progress.value);
    if (blocked) return blocked;
    currentStep.value = key;
    return null;
  }

  /** 整条流水线重来：清空所有已完成标记，回到第一步 */
  function resetAll() {
    progress.value = {};
    currentStep.value = 'topic';
  }

  function setBusy(value: boolean) {
    busy.value = value;
  }

  return { currentStep, progress, busy, steps, currentMeta, currentIndex, completedCount, markDone, reset, resetAll, goTo, setBusy };
});
